import { useSelector } from "react-redux";
import useLogger from "./useLogger";
import usePortalType from "./usePortalType";

const useTrackCSRLoginAsUser = () => {
  const logger = useLogger();
  const portalType = usePortalType();
  const { csrUser } = useSelector((s) => s.csrUser);

  return (user) => {
    logger.trackEvent("CSRLoginAsUser", {
      csrRoleName: csrUser?.role?.roleName ?? "",
      csrUserName: csrUser?.userName ?? "",
      portal: portalType ?? "",
      roleName: user?.role?.roleName ?? "",
      userName: user?.userName ?? "",
    });
  };
};

export default useTrackCSRLoginAsUser;
